var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeaturedicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 23.0801V24.0001C37.9988 26.1565 37.3005 28.2548 36.0093 29.9819C34.7182 31.7091 32.9033 32.9726 30.8354 33.584C28.7674 34.1954 26.5573 34.122 24.5345 33.3747C22.5117 32.6274 20.7847 31.2462 19.611 29.4372C18.4373 27.6281 17.8798 25.4882 18.0217 23.3364C18.1636 21.1847 18.9972 19.1364 20.3983 17.4972C21.7994 15.8579 23.6928 14.7155 25.7962 14.2403C27.8996 13.765 30.1003 13.9824 32.07 14.8601M38 16.0001L28 26.0101L25 23.0101",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedicon);
export default __webpack_public_path__ + "static/media/Featuredicon.dbe41d08b2970d9b8dbed3ebfd126d41.svg";
export { ForwardRef as ReactComponent };